/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export default function ListItemIcon () {
    return {
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 24,
                },
            },
        },
    };
}
